<template>
  <div class="lp-main-container">
    <nav id="nav-landing-page" class="lp-nav">
      <img class="lp-imagen" :src="logo" alt="Logo de CONTPAQi Firma" />
      <ul>
        <li>
          <a id="link-registrate" :href="identidadesSingin">Registrate</a>
        </li>
        <li>
          <a id="link-iniciar-sesion" :href="identidadesSingin"
            >Iniciar Sesión</a
          >
        </li>
        <li>
          <a id="link-ayuda" href="#">Ayuda</a>
        </li>
      </ul>
    </nav>
    <section class="lp-hero">
      <div class="lp-div-registrate">
        <p class="lp-titular">
          <span class="lp-enfasis">CONTPAQi®</span> ha creado una solución de
          <span class="lp-enfasis">firmas digitales</span> para tu negocio.
        </p>
        <p>Entra a la transformación digital mientras reduces tus costos.</p>
        <a :href="identidadesSingin" class="lp-registrate">Regístrate</a>
      </div>
      <div class="lp-div-docfirma">
        <img :src="docFirma" alt="Documento Firma" />
      </div>
    </section>
    <section class="lp-features">
      <div class="lp-features-title">Tipos de Firmas</div>
      <div class="lp-tipos-firmas-container">
        <div class="lp-tipo-firma">
          <img :src="firma1" alt="Firma1" />
          <h5>Contratos</h5>
        </div>
        <div class="lp-tipo-firma">
          <img :src="firma2" alt="Firma3" />
          <h5>Convenios</h5>
        </div>
        <div class="lp-tipo-firma">
          <img :src="firma3" alt="Firma3" />
          <h5>Pagares</h5>
        </div>
      </div>
    </section>
    <section class="lp-video">
      <div class="video-wrapper">
        <iframe
          title="Caracteristicas de CONTPAQi Firma"
          src="https://player.vimeo.com/video/502346183"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </section>
    <section class="lp-awards">
      <div class="lp-awards-psc">
        <img :src="logoWhite" alt="Logo CONTPAQi" />
        <p class="lp-titular">
          Somos el PAC <span class="lp-enfasis">NÚMERO 1*</span>
        </p>
        <p>
          Proveedor Autorizado de Certificación por el SAT. Certificado
          entregado a MasFacturación, S de R.L. de C.V empresa del grupo
          CONTPAQi®
        </p>
      </div>
      <div class="lp-awards-logros">
        <ul>
          <li>Mas de un millon de empresas timbra con nosotros.</li>
          <li>
            Hemos timbrado más de 2,000,000,000(dos mil millones) de facturas**.
          </li>
          <li>
            Únicos en México con la certificación internacional ISO 27001.
          </li>
          <li>Primer casa de software autorizada como PAC por el SAT.</li>
          <li>
            Lideres en facturación electriónica (tenemos la mayor participacion
            del mercado).
          </li>
        </ul>
        <p>
          **FUENTE SAT, cifras a noviembre de 2018, sin considerar quienes
          ofrecen servicios a instituciones bancarias.
        </p>
        <a :href="identidadesSingin" class="lp-registrate">Regístrate</a>
      </div>
    </section>
    <footer class="lp-footer">
      <img class="lp-imagen" :src="logoLeyenda" alt="Logo de CONTPAQi" />
      <ul>
        <li>
          <img :src="facebook" alt="Logo de CONTPAQi" />
        </li>
        <li>
          <img :src="twitter" alt="Logo de CONTPAQi" />
        </li>
        <li>
          <img :src="youtube" alt="Logo de CONTPAQi" />
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import logo from '@/assets/Logo_Contpaqi_Firma.svg'
import docFirma from '@/assets/Documento_Firma.svg'
import firma1 from '@/assets/Firma1.svg'
import firma2 from '@/assets/Firma2.svg'
import firma3 from '@/assets/Firma3.svg'
import logoWhite from '@/assets/Contpaqi_white.svg'
import logoLeyenda from '@/assets/Contpaqi_white_leyenda.svg'
import facebook from '@/assets/Facebook.svg'
import twitter from '@/assets/Twitter.svg'
import youtube from '@/assets/YouTube.svg'

import { userData } from '@/store/helpers'

export default {
  name: 'MainLandingPage',
  data() {
    return {
      logo,
      docFirma,
      firma1,
      firma2,
      firma3,
      logoWhite,
      logoLeyenda,
      facebook,
      twitter,
      youtube
    }
  },
  computed: {
    ...userData
  }
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@400;700&display=swap');

* {
  box-sizing: border-box;
}

.lp-imagen {
  margin: 0 0 0 6em;
}

.lp-titular {
  font: normal normal normal 35px/40px Titillium Web, Helvetica, Arial, Verdana,
    Tahoma, sans-serif;
  text-transform: uppercase;
}

.lp-enfasis {
  font: normal normal bold 35px/40px Titillium Web, Helvetica, Arial, Verdana,
    Tahoma, sans-serif;
}

.lp-registrate {
  text-decoration: none;
  font: normal normal 600 18px/24px Titillium Web, Helvetica, Arial, Verdana,
    Tahoma, sans-serif;
  width: 25em;
  margin: 0.5rem 0;
  padding: 0.5em 1.5em;
  background: #00eed7 0% 0% no-repeat padding-box;
  border-radius: 10px;
}

.lp-main-container {
  display: grid;
  justify-items: center;
  height: 100vh;
  grid-template-columns: 0.1fr 1fr 0.1fr;
  grid-template-rows: 150px 400px 300px 596px 396px 150px;
}

.lp-nav {
  grid-column: 2;
  grid-row: 1;
  justify-self: stretch;
  align-self: stretch;

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  font: normal normal normal 18px/40px Titillium Web, Helvetica, Arial, Verdana,
    Tahoma, sans-serif;
  color: #555555;

  ul {
    display: flex;
    list-style: none;
    li {
      width: 120px;
      text-align: center;
      text-transform: capitalize;

      a {
        text-decoration: none;
        color: #555555;
      }
    }
  }
}

.lp-hero {
  grid-column: 2;
  justify-self: stretch;
  align-self: stretch;
  background: transparent
    linear-gradient(107deg, #0026a4 0%, #00b4b8 48%, #00eed7 100%) 0% 0%
    no-repeat padding-box;

  display: flex;
  align-items: center;
  justify-content: space-around;

  p {
    color: white;
    margin-bottom: 1.5rem;
  }

  .lp-div-registrate {
    margin: 0 6em;
  }

  .lp-div-docfirma {
    margin: 0 6em 0 0;
  }
}

.lp-features {
  grid-column: 2;
  grid-row: 3;
  justify-self: stretch;
  align-self: stretch;
  background-color: #f2f2f2;

  padding: 1.5em 0 0 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  .lp-features-title {
    color: #555555;
    align-self: center;
    font: normal normal normal 30px/24px Titillium Web, Helvetica, Arial,
      Verdana, Tahoma, sans-serif;
  }

  .lp-tipos-firmas-container {
    display: flex;
    justify-content: space-around;

    .lp-tipo-firma {
      height: 130px;
      display: flex;
      margin: 0 3rem;
      flex-direction: column;
      justify-content: space-between;

      h5 {
        text-align: center;
        font: normal normal normal 16px/24px Titillium Web, Helvetica, Arial,
          Verdana, Tahoma, sans-serif;
        color: #555555;
      }
    }
  }
}

.lp-video {
  grid-column: 2;
  grid-row: 4;
  justify-self: stretch;
  align-self: stretch;
  display: grid;
  justify-items: center;
  align-items: center;
}

.video-wrapper {
  position: relative;
  height: 480px;
  width: 720px;
}

.video-wrapper object,
.video-wrapper embed,
.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.lp-awards {
  grid-column: 2;
  grid-row: 5;
  justify-self: stretch;
  align-self: stretch;
  background: transparent linear-gradient(107deg, #0026a4 0%, #33c1ff 100%) 0%
    0% no-repeat padding-box;
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 6em;
}

.lp-footer {
  grid-column: 2;
  grid-row: 6;
  justify-self: stretch;
  align-self: stretch;
  background: #003a70 0% 0% no-repeat padding-box;

  display: flex;
  justify-content: space-between;
  align-items: center;

  ul {
    display: flex;
    list-style: none;
    padding-right: 6em;
    li {
      width: 80px;
      text-align: center;
      text-transform: capitalize;

      a {
        text-decoration: none;
        color: #555555;
      }
    }
  }
}

/* Medium screens */
@media all and (max-width: 1280px) {
  .lp-nav {
    justify-content: space-around;
  }

  .lp-hero {
    justify-content: space-around;
  }

  .lp-main-container {
    grid-template-columns: 0.1fr;
    grid-template-rows: 150px 600px 300px 596px 496px 150px;
  }

  .lp-titular {
    font: normal normal normal 28px/30px Titillium Web, Helvetica, Arial,
      Verdana, Tahoma, sans-serif;
  }

  .lp-enfasis {
    font: normal normal bold 28px/30px Titillium Web, Helvetica, Arial, Verdana,
      Tahoma, sans-serif;
  }

  .video-wrapper {
    height: 360px;
    width: 640px;
  }
}

/* Medium screens */
@media all and (max-width: 950px) {
  .lp-nav {
    justify-content: space-around;
  }

  .lp-hero {
    justify-content: space-around;
  }

  .lp-main-container {
    grid-template-columns: 0.1fr;
    grid-template-rows: 150px 600px 300px 596px 496px 150px;
  }

  .lp-titular {
    font: normal normal normal 28px/30px Titillium Web, Helvetica, Arial,
      Verdana, Tahoma, sans-serif;
  }

  .lp-enfasis {
    font: normal normal bold 28px/30px Titillium Web, Helvetica, Arial, Verdana,
      Tahoma, sans-serif;
  }

  .video-wrapper {
    height: 360px;
    width: 640px;
  }
}

/* Small screens */
@media all and (max-width: 600px) {
  .lp-main-container {
    grid-template-columns: 0.1fr;
    grid-template-rows: 150px 800px 300px 596px 696px 150px;
  }

  .lp-imagen {
    margin: 0;
  }

  .lp-nav {
    flex-direction: column;
  }
  .lp-hero {
    flex-direction: column;

    .lp-div-docfirma {
      margin: 0;
    }
  }

  .lp-awards {
    flex-direction: column;
  }

  .lp-footer {
    ul {
      padding-right: 0;
    }
  }


  .lp-titular {
    font: normal normal normal 25px/30px Titillium Web, Helvetica, Arial,
      Verdana, Tahoma, sans-serif;
  }

  .lp-enfasis {
    font: normal normal bold 25px/30px Titillium Web, Helvetica, Arial, Verdana,
      Tahoma, sans-serif;
  }

  .video-wrapper {
    height: 270px;
    width: 480px;
  }
}
</style>
